import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M21.25 12a9.25 9.25 0 1 0-18.5 0 9.25 9.25 0 0 0 18.5 0m-9.692 1.521q.028.454.44.454.411 0 .44-.454l.313-5.58a.77.77 0 0 0-.185-.625.7.7 0 0 0-.568-.256.72.72 0 0 0-.582.256.84.84 0 0 0-.185.624zm-.185 3.28q.199.2.554.2h.142q.368 0 .554-.2.184-.199.184-.553v-.256q0-.369-.184-.554-.185-.2-.554-.199h-.142q-.355 0-.554.2-.184.184-.184.553v.255q0 .356.184.554",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }